import React from 'react';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const UploadIcon = () => (
  <Icon tooltip="Upload" iconObj={faUpload} />
);

export default UploadIcon;